/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Item_3_LabelInputs */

const en_wb_management_item_3_label = /** @type {(inputs: Wb_Management_Item_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaign review:`)
};

const lv_wb_management_item_3_label = /** @type {(inputs: Wb_Management_Item_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampaņas pārskats:`)
};

/**
* | output |
* | --- |
* | "Campaign review:" |
*
* @param {Wb_Management_Item_3_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_item_3_label = /** @type {((inputs?: Wb_Management_Item_3_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Item_3_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_item_3_label(inputs)
	return en_wb_management_item_3_label(inputs)
});